import { Directive, OnChanges, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoBlank]'
})
export class NoBlankDirective {

  @HostListener('keyup', ['$event']) inputChanged(event) {
    const regex = /^\s*$/;
    regex.test(event.target.value) ? event.target.value = '' : false;
  }

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/no-blank.directive.ts